
import React, { Component, useEffect, useState } from "react";
import UserService from "../../services/user.service";
import styled from 'styled-components'
import { useTable } from 'react-table'
import { Input } from "reactstrap";
const Moment = require('moment-timezone');
const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`


function Table({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  })

  // Render the UI for your table
  return (
    <table {...getTableProps()}>
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps()}>{column.render('Header')}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row)
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map(cell => {
                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
              })}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

const LogTable = () => {
    
    const [logentries, setLogEnties] = useState([]);
    const [filtered_logentries, setFilteredLogEnties] = useState([]);
    const [robotids, setRobotIDs] = useState([]);
    useEffect(() => {
        UserService.getLog().then(
      (response) => {
        var log_entries = response.data;
        log_entries.forEach(function (log_entry, index) {
          log_entry['time'] = Moment.tz(log_entry['time'], "Asia/Hong_Kong").format();
        });

               
        setLogEnties(log_entries);
        setFilteredLogEnties(log_entries);
        
        const unique = [...new Set(response.data.map(item => item.robotid))];
        setRobotIDs(unique);
       //console.log(unique);
      },
      (error) => {
        const _content = 
          (error.response && error.response.data) || 
          error.message ||
          error.toString();
        
      }
    );
  }, []);


  
const handleSelectedSite = (robotid) => {
  console.log(robotid);
  // Here I make a copy of the original data using json.stringify
  // so it doesn't mutate the original state
  let filtered_entries = logentries.filter(entry => entry.robotid == robotid)

  setFilteredLogEnties(filtered_entries);
}


    const columns = React.useMemo(
        () => [
            {
                Header: 'Robot ID',
                accessor: 'robotid',
              },
              {
                Header: 'Profile',
                accessor: 'profile',
              },
              {
                Header: 'Activity',
                accessor: 'activity',
              },
              {
                Header: 'Time',
                accessor: 'time',
              },

              
              {
                Header: 'Communication Mode',
                accessor: 'communicationmode',
              },
              {
                Header: 'Description',
                accessor: 'description',
              },
        ],
        []
      )
      const MakeItem = function(X) {
        return <option key={X}>{X}</option>;
    };
      const rows = [
        { id: '0', title: 'Example' },
        { id: '1', title: 'Demo' }
      ];

    return (
        <div className="robot_list">
<Input
          type="select"
          id="vesselName"
          onChange={e => handleSelectedSite(e.target.value)}
        >
          
            {robotids.map(MakeItem
            )};
          
        </Input>

        <Styles>
      
      <Table columns={columns} data={filtered_logentries} />
    </Styles>
    </div>
      );
}

export default LogTable;
